import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";
import "react-toastify/dist/ReactToastify.css";
import PageTitle from "../store/PageTitle";
import airtelIcon from "../home/img/white-1024x768.jpg";
import mtnIcon from "../home/img/mtn-money.png";
import zamtelIcon from "../home/img/ZamtelLogo_White-m85aPxq2.png";
import Loader from "../home/Loader";
import axios from "axios";

const serverUrl = process.env.REACT_APP_SERVER_URL;

const Payment = ({ toggleLogin }) => {
  const [paymentType] = useState("mobile_money");
  const user = useSelector((state) => state.auth.user);
  const [phone, setPhone] = useState(""); // For mobile money
  const location = useLocation();
  const { paymentDetails } = location.state || {};

  const token = useSelector((state) => state.auth.token);

  const user_avatar =
    user?.identities?.find((identity) => identity?.provider === "google")
      ?.identity_data?.avatar_url || null;

  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const referenceNo = `REF-${Date.now()}`;
    setLoading(true);

    try {
      // Create order first
      const orderData = {
        user_infor: paymentDetails?.user,
        user_avatar: user_avatar,
        checkoutItems: paymentDetails?.items,
        totalAmount: paymentDetails?.payment?.total,
        deliveryAddress: paymentDetails?.delivery,
        deliveryMethod: paymentDetails?.deliveryMethod,
        paymentMethod: paymentType,
        paymentStatus: "pending",
        paymentReference: referenceNo,
      };
      console.log("order data", orderData);

      const orderResponse = await axios.post(
        `${serverUrl}/create-order`,
        orderData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!orderResponse.data.success) {
        throw new Error("Order creation failed");
      }

      const orderId = orderResponse.data.orderId;
      toast.success("Order created! Processing payment...");

      // Prepare payment payload
      let paymentPayload = {
        referenceNo,
        amount: paymentDetails?.payment?.total,
        currency: "ZMW",
        receiverId: "26" + phone,
        paymentType: selectedProvider.value,
        orderId,
      };

      // Initiate payment request
      const endpoint = "/mobile-money";
      const paymentResponse = await axios.post(
        `${serverUrl}${endpoint}`,
        paymentPayload
      );
      console.log("Payment response:", paymentResponse.data);
      // Start payment status polling
      let attempts = 0;
      const maxAttempts = 12;

      const pollingInterval = setInterval(async () => {
        if (attempts >= maxAttempts) {
          clearInterval(pollingInterval);
          setLoading(false);
          Swal.fire({
            icon: "warning",
            title: "Payment checking time-out",
            text: "Please check your payment on your order dashboard",
            confirmButtonText: "Okay",
            showCancelButton: true,
            cancelButtonText: "My Orders",
            willClose: () => {
              window.location.href = "/OrdersTable";
            },
          });
          return;
        }

        attempts++;

        try {
          const statusResponse = await axios.get(
            `${serverUrl}/order-status/${orderId}`
          );
          const paymentStatus = statusResponse.data.payment_status;

          if (paymentStatus !== "pending") {
            clearInterval(pollingInterval);
            setLoading(false);

            if (paymentStatus === "paid") {
              Swal.fire({
                icon: "success",
                title: "Payment Successful!",
                text: "Your order has been confirmed!",
                confirmButtonText: "View Order",
                willClose: () => {
                  window.location.href = "/OrdersTable";
                },
              });
            } else {
              Swal.fire({
                icon: "error",
                title: "Payment Failed",
                text: "Please try again or contact support",
                confirmButtonText: "Okay",
                showCancelButton: true,
                cancelButtonText: "Contact Support",
                willClose: () => {
                  window.location.href = "/Contact";
                },
              });
            }
          }
        } catch (error) {
          clearInterval(pollingInterval);
          setLoading(false);
          toast.error("Error checking payment status: " + error.message);
        }
      }, 5000);
    } catch (error) {
      setLoading(false);
      if (error.response && error.response.status === 401) {
        toast.error("Oops one more step. Please log in again.");
        toggleLogin();
      }
      let errorMessage = error.message;

      if (error.response) {
        // Server responded with error
        errorMessage = error.response.data.error || error.response.statusText;
      } else if (error.request) {
        // No response received
        errorMessage = "Network error - please check your connection";
      }

      toast.error(`Error: ${errorMessage}`);
    }
  };

  const paymentOptions = [
    {
      value: "AIRTEL_OAPI_ZMB",
      label: "Airtel Mobile Money",
      icon: airtelIcon,
    },
    {
      value: "MTN_MOMO_ZMB",
      label: "MTN Mobile Money",
      icon: mtnIcon,
    },
    {
      value: "ZAMTEL_KWACHA_ZMB",
      label: "Zamtel Kwacha",
      icon: zamtelIcon,
    },
  ];

  const [showDropdown, setShowDropdown] = useState(false);

  const [selectedProvider, setSelectedProvider] = useState(paymentOptions[0]);

  return (
    <div className="pay">
      <PageTitle title="Payment" />
      {loading && <Loader />}
      <div className="payment-container">
        <h2 className="payment-title">Payment Details</h2>
        <form onSubmit={handleSubmit} className="payment-form">
          <div className="form-group">
            <label htmlFor="payment-type">Payment Provider</label>
            <div className="custom-select" tabIndex={0}>
              <div
                className="selected-option"
                onClick={() => setShowDropdown((prev) => !prev)}
              >
                <img
                  src={selectedProvider.icon}
                  alt=""
                  className="option-icon"
                />
                {selectedProvider.label}
              </div>
              {showDropdown && (
                <div className="options-list">
                  {paymentOptions.map((option) => (
                    <div
                      key={option.value}
                      className="option-item"
                      onClick={() => {
                        setSelectedProvider(option);
                        setShowDropdown(false);
                      }}
                    >
                      <img src={option.icon} alt="" className="option-icon" />
                      {option.label}
                    </div>
                  ))}
                </div>
              )}
            </div>
            {/* Hidden select for form compatibility */}
            <select
              id="payment-type"
              className="form-control"
              value={selectedProvider.value}
              style={{ display: "none" }}
              readOnly
            >
              {paymentOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="amount">Amount</label>
            <input
              id="amount"
              type="number"
              className="form-control"
              value={paymentDetails?.payment?.total}
              disabled // Disables user input completely
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone">Phone Number</label>
            <input
              id="phone"
              type="tel"
              className="form-control"
              value={phone}
              maxLength={10}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="e.g, 0 97X XXX XXX"
              required
            />
          </div>

          <button type="submit" className="submit-button">
            Pay Now
          </button>
          <ToastContainer position="top-center" />
        </form>

        <style>{`
        .pay{
          margin:10%
        }
        .payment-container {
          max-width: 500px;
          margin: 0 auto;
          padding: 2rem;
          background-color: #ffffff;
          border-radius: 10px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
        }
        
        .payment-title {
          color: #333;
          font-size: 1.5rem;
          margin-bottom: 1.5rem;
          font-weight: 600;
          text-align: center;
        }
        
        .payment-form {
          display: flex;
          flex-direction: column;
          gap: 1.25rem;
        }
        .form-flex{
          display:flex;
          justify-content: space-between;
        }
        
        .form-group {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
        }
        
        label {
          font-size: 0.9rem;
          font-weight: 500;
          color: #4a5568;
        }
        
        .form-control {
          width: 100%;
          padding: 0.75rem 1rem;
          border: 1px solid #e2e8f0;
          border-radius: 6px;
          font-size: 1rem;
          transition: border-color 0.2s, box-shadow 0.2s;
        }
        
        .form-control:focus {
          outline: none;
          border-color: #3b82f6;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
        }
        
        .submit-button {
          margin-top: 0.75rem;
          padding: 0.75rem 1rem;
          background-color: #3b82f6;
          color: white;
          border: none;
          border-radius: 6px;
          font-size: 1rem;
          font-weight: 500;
          cursor: pointer;
          transition: background-color 0.2s;
        }
        
        .submit-button:hover {
          background-color: #2563eb;
        }
        
        .submit-button:active {
          background-color: #1d4ed8;
        }
        
        select.form-control {
          appearance: none;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%234a5568' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'%3E%3C/path%3E%3C/svg%3E");
          background-repeat: no-repeat;
          background-position: right 1rem center;
          background-size: 1rem;
          padding-right: 2.5rem;
        }

        .input-wrapper {
          position: relative;
          display: flex;
          align-items: center;
          }

          .input-wrapper input {
          padding-left: 40px; /* Space for the icon */
          }

          .input-wrapper .icon {
          position: absolute;
          left: 10px;
          top: 50%;
          transform: translateY(-50%);
          color: gray;
          }

          .custom-select {
            position: relative;
            width: 100%;
            cursor: pointer;
          }
          .selected-option, .option-item {
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 0.75rem 1rem;
            border: 1px solid #e2e8f0;
            border-radius: 6px;
            background: #fff;
          }
          .options-list {
            position: absolute;
            width: 100%;
            background: #fff;
            border: 1px solid #e2e8f0;
            border-radius: 6px;
            z-index: 10;
            margin-top: 2px;
          }
          .option-item:hover {
            background: #f0f4f8;
          }
          .option-icon {
            width: 24px;
            height: 24px;
            object-fit: contain;
          }

        
        @media (max-width: 640px) {
          .payment-container {
            padding: 1.5rem;
            border-radius: 8px;
          }
        }
      `}</style>
      </div>
    </div>
  );
};

export default Payment;
